'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACT',
    link: '/contact'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense',
      src: '/expense-management'
    }, {
      text: 'Travel Booking',
      src: '/travel-booking'
    }, {
      text: 'Intelligence',
      src: '/business-intelligence'
    }, {
      text: 'Invoice',
      src: '/invoice-management'
    }, {
      text: 'Concur Locate',
      src: '/concur-locate'
    }, {
      text: 'Concur Drive',
      src: '/concur-drive'
    }, {
      text: 'Budget Management',
      src: '/budget-management'
    }]
  }, {
    title: {
      text: 'FEATURES'
    },
    list: [{
      text: 'Mobile App',
      src: '/mobile'
    }, {
      text: 'Compliance',
      src: '/compliance'
    }, {
      text: 'Audit',
      src: '/expense-audit'
    }, {
      text: 'Software Integration',
      src: '/financial-connectors'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'SAP Integration',
      src: '/sap-integration'
    }, {
      text: 'Why Concur',
      src: '/why-concur'
    }, {
      text: 'Office Locations',
      src: '/contact/offices'
    }, {
      text: 'Contact Sales',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Newsroom',
      src: ''
    }, {
      text: 'Events',
      src: '/events'
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR BLOG',
    href: ''
  }, {
    text: 'CONTACT',
    href: '/contact'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};